export default __webpack_public_path__ + "static/media/marketing-1.bc57ebf1.jpg";